import { combineReducers } from '@reduxjs/toolkit';
import userReducer from '../slice/userSlice';
import blogReducer from '../slice/blogSlice';
import otpReducer from '../slice/otpSlice';
import instituteReducer from '../slice/instituteSlice';
import errorSlice from '../slice/errorSlice';
import courseSlice from '../slice/courseSlice';
import droneCategorySlice from '../slice/droneCategorySlice';
import droneJobSlice from '../slice/droneJobsSlice';
import workshopReducer from '../slice/workshopSlice'; // ✅ Add this
import leadReducer from "../slice/hduySlice";


const rootReducer = combineReducers({
  user: userReducer,
  blog: blogReducer,
  otp: otpReducer,
  institute: instituteReducer,
  error: errorSlice,
  course: courseSlice,
  droneCategory: droneCategorySlice,
  droneJob: droneJobSlice,
  workshop: workshopReducer, // ✅ Add this
  lead: leadReducer,
});

export default rootReducer;
